import {
  ReduxHelperItem,
  ActionFunc,
  ReduxStateObj,
  ReducerFunc,
  AsyncParamFunc,
  ActionObj,
} from "./types";
import { createAsyncHelper } from "./AsyncHelper";

export function combine<H extends Record<string, ReduxHelperItem> = any>(
  helperMap: H
): {
  actions: { [key in keyof H]: ActionFunc };
  reducer: ReducerFunc;
} {
  const actions = {} as {
    [key in keyof H]: ActionFunc;
  };
  const state: ReduxStateObj = {};
  const reducerList: ReducerFunc<ReduxStateObj>[] = [];

  Object.keys(helperMap).forEach((name) => {
    let helper = helperMap[name];
    if (typeof helper === "function") {
      helper = helper({
        async: (task: AsyncParamFunc) => createAsyncHelper(name as string, task),
      });
    }
    const actionKey: keyof H = name;
    actions[actionKey] = helper.action;
    Object.assign(state, helper.state);
    reducerList.push(helper.reducer);
  });

  return {
    actions,
    reducer: mergeReducers(state, reducerList),
  };
}

// 合并多个 reducer，使其可重复对同一个 state 做不同操作
function mergeReducers<P = any, V = any>(
  initialState: ReduxStateObj<P, V>,
  reducers: ((state: ReduxStateObj<P, V>, action: ActionObj<P, V>) => ReduxStateObj<P, V>)[]
) {
  return (state = initialState, action: ActionObj<P, V>): ReduxStateObj<P, V> => {
    reducers.forEach((reducer) => {
      state = reducer(state, action);
    });
    return state;
  };
}
